import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { setAuthState } from '../../services/redux/auth/auth-actions'
import { AUTH_LOCAL_STORAGE_KEY } from '../../services/redux/auth/auth-types'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { UserRole } from '../../services/api/sharedTypes/User'

const LogoutDialog: React.FC = () => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const logout = () => {
        localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
        dispatch(
            setAuthState({
                isAuthenticated: false,
                parsedToken: {
                    CreatedTimestamp: 0,
                    UserId: '',
                    Username: '',
                    expiration: 0,
                    IntegrityHash: '',
                    RefreshIntervalInSeconds: 0,
                    RefreshTimestamp: 0,
                    Role: UserRole.NotSet,
                },
                token: '',
                userName: '',
                role: UserRole.NotSet,
            })
        )
        navigate('/')
    }

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    return (
        <>
            <Button variant='contained' onClick={handleOpenDialog}>
                Odhlásit se
            </Button>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>Opravdu se chcete odhlásit?</DialogTitle>
                <DialogActions>
                    <Button variant='outlined' onClick={handleCloseDialog}>
                        Ne
                    </Button>
                    <Button onClick={logout} variant='contained' autoFocus>
                        Ano
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default LogoutDialog
